export default {
  getContentsByType: (state: any) => (type: string) => {
    return state[type];
  },
};
